import React from "react";
import "./Title.css"

export const Title = () => {
    return (
        <div>
            <p className="title">Tic Tac Toe</p>
            <p className="small">Made using <a className="diff" href="https://reactjs.org/" target="_blank"> React.js</a></p>
        </div>
    )
}